module.exports = __webpack_public_path__ + "img/crew.d4c9aaa8.svg";